import { getErrorMessage } from 'application/util/error.util';

import './sign-in.style.sass';
import template from './sign-in.tpl.pug';

class SignInController {
    /* @ngInject */
    constructor($state, $stateParams, sessionService, navigationService, appStartCacheService, storageService, notificationService, diagnosticsService) {
        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;
        this.appStartCacheService = appStartCacheService;
        this.notificationService = notificationService;
        this.diagnosticsService = diagnosticsService;

        this.error = $stateParams.error || null;
        this.redirect = $stateParams.redirect || null;

        this.diagnosticsService.info('sign_in_page_init', {
            hasSessionUser: !!this.sessionService.user,
            stateName: this.$state.current && this.$state.current.name,
            hasErrorParam: !!this.error,
            hasRedirectParam: !!this.redirect
        });

        if (!this.sessionService.user) {
            this.appStartCacheService.clearAll();
            storageService.setUserPrefix(null);
            this.appStartCacheService.reset();
        }

        this.canSendDiagnostics = this.diagnosticsService.canSend();
    }

    signIn(email, password) {
        return this.sessionService.signIn(email, password).then(() => {
            let { state, params } = this.navigationService.getStateFromRedirectUrl(this.redirect) || {};

            this.$state.go(state || 'authorized.calendar', params || {});
        }, (result) => {
            let error = result.data && result.data.error === 'INVALID_GRANT'
                ? 'Incorrect email address or password.'
                : getErrorMessage(result, `Sorry, but we were not able to sign you in. Please try again later.`);

            if (result.data && result.data.error === 'ACCOUNT_EXPIRED') {
                this.$state.go('identity.email-verification.request', {
                    error,
                    email
                });

                return;
            }

            this.error = error;
        });
    }

    sendDiagnostics() {
        if (this.sendingDiagnostics) {
            return;
        }

        this.sendingDiagnostics = true;

        return this.diagnosticsService.send({
            source: 'sign-in',
            identity: this.email || null,
            context: {
                hasError: !!this.error
            }
        }).then((result) => {
            const diagnosticsId = result && result.data && result.data.id;
            const message = diagnosticsId
                ? `Diagnostics sent. ID: ${diagnosticsId}`
                : `Diagnostics sent. Thank you.`;

            this.notificationService.showInfo(message, null, true, 6000);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to send diagnostics. Please try again later.`));
        }).finally(() => {
            this.sendingDiagnostics = false;
        });
    }
}

export default {
    selector: 'dbASignIn',
    template: template(),
    controller: SignInController
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/sign-in/sign-in.cmpt.js